import PatientUpdateDocumentFormContainer from './PatientUpdateDocumentFormContainer';

export default PatientUpdateDocumentFormContainer;
